import { Component } from '@angular/core';
import { AlertController, ModalController } from 'ionic-angular';

import { FoodModel } from '../../models/models';
import { FoodEditPage } from './food-edit';
import { ConfigurationProvider, FoodProvider } from '../../providers/providers';

@Component({
  selector: 'page-food-inventory',
  templateUrl: 'food-inventory.html',
})
export class FoodInventoryPage {
  foodList: any = [];
  page: string = 'inventory';

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private foodProvider: FoodProvider,
    private modalCtrl: ModalController) {
  }

  doAddFood(item: FoodModel = new FoodModel()) {
    let modal = this.modalCtrl.create(FoodEditPage, { 
      item: item
    });
    modal.present();

    modal.onDidDismiss(data => {
      if (data && data.saved && data.name) {
        this.config.showToast('"' + data.name + '" saved!');
        this.loadView();
      }
    });
  }

  doRemove(item: FoodModel) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure? This food item will also be removed from all meals where it is used.',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            this.config.showLoading();
            this.foodProvider.Remove(item).then((items) => {
              this.foodList = items;
              this.config.showToast(item.Name + ' removed!');
              this.config.dismissLoading();
            });
          }
        }
      ]
    });
    confirm.present();
  }

  ionViewDidLoad() {
    this.loadView();
  }

  loadView() {
    const processList = () => {
      if (this.foodList) {
        this.foodList = this.foodProvider.Sort();
        for (let item of this.foodList) {
          item.icon = 'arrow-dropright';
          item.showDetails = false;
        }
      }
    };

    this.foodList = this.foodProvider.List();

    if (this.foodList.length > 0) {
      processList();
    }
    else {
      this.config.showLoading();
      this.foodProvider.Load().then(() => {
        processList();
        this.config.dismissLoading();
      });
    }
  }

  toggleDetails(item) {
    if (item.showDetails) {
      item.showDetails = false;
      item.icon = 'arrow-dropright';
    }
    else {
      item.showDetails = true;
      item.icon = 'arrow-dropdown';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/food/food-inventory.ts